import React from "react";

const UserSearch = ({
  searchQuery,
  setSearchQuery,
  genderFilter,
  setGenderFilter,
  minAgeFilter,
  setMinAgeFilter,
  maxAgeFilter,
  setMaxAgeFilter,
  countryFilter,
  setCountryFilter,
  stateFilter,
  setStateFilter,
  cityFilter,
  setCityFilter,
  sortBy,
  setSortBy,
  handleSearch,
}) => {
  const handleSortChange = (e) => {
    setSortBy(e.target.value);
    handleSearch();
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    if (name === "country") {
      setCountryFilter(value);
    } else if (name === "state") {
      setStateFilter(value);
    } else if (name === "city") {
      setCityFilter(value);
    }
  };

  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-4 bg-white p-4 rounded-xl shadow-md">
      <div className="flex items-center space-x-2">
        <label className="text-sm font-medium text-gray-700">Tìm:</label>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Tìm kiếm người dùng..."
          className="border p-2 rounded shadow-sm focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="flex items-center space-x-2">
        <label className="text-sm font-medium text-gray-700">Giới tính:</label>
        <select
          value={genderFilter}
          onChange={(e) => setGenderFilter(e.target.value)}
          className="border p-2 rounded shadow-sm focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Tất cả</option>
          <option value="male">Nam</option>
          <option value="female">Nữ</option>
          <option value="other">Khác</option>
        </select>
      </div>
      <div className="flex items-center space-x-2">
        <label className="text-sm font-medium text-gray-700">Tuổi:</label>
        <select
          value={minAgeFilter}
          onChange={(e) => setMinAgeFilter(e.target.value)}
          className="border p-2 rounded shadow-sm focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Từ</option>
          {[...Array(83)].map((_, i) => (
            <option key={i} value={18 + i}>{18 + i}</option>
          ))}
        </select>
        <select
          value={maxAgeFilter}
          onChange={(e) => setMaxAgeFilter(e.target.value)}
          className="border p-2 rounded shadow-sm focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Đến</option>
          {[...Array(83)].map((_, i) => (
            <option key={i} value={18 + i}>{18 + i}</option>
          ))}
        </select>
      </div>
      <div className="flex items-center space-x-2">
        <label className="text-sm font-medium text-gray-700">Quốc gia:</label>
        <input
          type="text"
          name="country"
          value={countryFilter}
          onChange={handleFilterChange}
          placeholder="Nhập quốc gia..."
          className="border p-2 rounded shadow-sm focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="flex items-center space-x-2">
        <label className="text-sm font-medium text-gray-700">Bang/Tỉnh:</label>
        <input
          type="text"
          name="state"
          value={stateFilter}
          onChange={handleFilterChange}
          placeholder="Nhập bang/tỉnh..."
          className="border p-2 rounded shadow-sm focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="flex items-center space-x-2">
        <label className="text-sm font-medium text-gray-700">Thành phố:</label>
        <select
          value={cityFilter}
          onChange={(e) => setCityFilter(e.target.value)}
          className="border p-2 rounded shadow-sm focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Tất cả</option>
          <option value="Bất Kỳ Thành Phố Nào">Bất Kỳ Thành Phố Nào</option>
          {/* Thêm các thành phố khác nếu cần */}
        </select>
      </div>
      <div className="flex items-center space-x-2">
        <label className="text-sm font-medium text-gray-700">Sắp Xếp Theo:</label>
        <select
          value={sortBy}
          onChange={handleSortChange}
          className="border p-2 rounded shadow-sm focus:ring-2 focus:ring-blue-500"
        >
          <option value="compatibility">Độ phù hợp</option>
          <option value="new_members">Viên mới</option>
          <option value="online_photos">Hình ảnh trực tuyến</option>
          <option value="last_activity">Lần hoạt động cuối</option>
        </select>
      </div>
      <button
        onClick={handleSearch}
        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        Tìm kiếm
      </button>
    </div>
  );
};

export default UserSearch;